import { Component, OnDestroy, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { SignupPreviousPath } from '../../../enum/landing-enum'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-functions-for-business',
  templateUrl: './functions-for-business.component.html',
  styleUrls: ['./functions-for-business.component.scss'],
})
export class FunctionsForBusinessComponent implements OnInit, OnDestroy {
  public customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING_ACCOUNTING',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_ACCOUNTING',
  }
  public reviewSectionTextListBusiness = {
    title: 'REVIEWS_PARTNERS_FLOWACCOUNT.BUSINESS.TITLE',
    detail: 'REVIEWS_PARTNERS_FLOWACCOUNT.BUSINESS.DETAIL',
    button: 'REVIEWS_PARTNERS_FLOWACCOUNT.BUSINESS.BTN',
  }
  public mockContent: object[]
  public signupPreviousPath = SignupPreviousPath
  protected langChangeSubscription: Subscription
  constructor(public translate: TranslateService, private seoService: SEOService, private titleService: Title) {
    this.setMeta()
    this.langChangeSubscription = translate.onLangChange.subscribe(() => {
      this.setMeta()
    })
  }
  ngOnInit() {
    this.showMockContent()
  }
  setMeta() {
    this.titleService.setTitle(this.translate.instant('metatitle-Function-business'))
    this.seoService.createMetaTag(
      this.translate.instant('metatitle-Function-business'),
      this.translate.instant('metaDescription-business'),
    )
    this.seoService.createOg(
      'https://flowaccountcdn.com/images/Thumnail_FlowPayroll_FlowAccount.png',
      this.translate.instant('metatitle-Function-business'),
      this.translate.instant('metaDescription-business'),
    )
  }

  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
  }
  showMockContent() {
    const lang = this.translate.currentLang.toUpperCase()
    this.mockContent = [
      {
        link: 'https://flowaccount.com/faq/knowledge-base/qr-request-tax-invoice',
        alt: 'TAX_INVOICE.BANNER.ALT_TEXT',
        image:
          'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/banner/qr-request_tax-invoice_' +
          lang +
          '.jpg',

        imageWebp:
          'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/banner/qr-request_tax-invoice_' +
          lang +
          '.webp',

        imageMobile:
          'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/banner/qr-request_tax-invoice_mobile_' +
          lang +
          '.jpg',

        imageMobileWebp:
          'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/banner/qr-request_tax-invoice_mobile_' +
          lang +
          '.webp',
      },
    ]
  }
}
